module.exports = __webpack_public_path__ + "statics/media/aspire-logo_color.80e2e80d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/aspire-logo/aspire-logo_color.svg
// module id = 1213
// module chunks = 138